{
	"portfolio": {
		"blocks": "Blocks",
		"portfolioValue": "Portfolio Value, USD",
		"portfolioValuation": "Portfolio Valuation",
		"marketValue": "Market value",
		"money": "Trade Cash",
		"buyingPowerStocks": "Stocks Buying Power",
		"buyingPowerOptions": "Options Buying Power",
		"profitability": "Profitability",
		"unrealizedPL": "Unrealized P&L",
		"perDayPL": "Daily P&L",
		"riskLevel": "Risk level",
		"margin": "MARGIN",
		"call": "CALL",
		"riskLevelsTitles": {
			"low": "Low risk",
			"moderate": "Moderate risk",
			"high": "High risk"
		}
	}
}
